import React from "react";
import { Input } from "antd";
import "./HotelSpecialRequest.scss";

const { TextArea } = Input;

export const SPECIAL_REQUEST_MAX_LENGTH = 50;

/**
 * Optional special request — edit on checkout, read-only on preview/ticket.
 * Renders nothing when read-only and empty.
 */
const HotelSpecialRequest = ({
  value = "",
  onChange,
  readOnly = false,
  /** Inside ticket card — no section title, plain text only */
  embedded = false,
}) => {
  const text = String(value ?? "").trim();
  const liveValue = String(value ?? "");

  if (readOnly && !text) {
    return null;
  }

  if (readOnly) {
    if (embedded) {
      return (
        <p className="hotel-special-request-readonly-text">{text}</p>
      );
    }
    return (
      <div className="hotel-special-request-block hotel-special-request-block--readonly">
        <p className="booking-summary-div">Special Request</p>
        <TextArea
          rows={4}
          value={text}
          readOnly
          className="hotel-special-request-textarea"
        />
      </div>
    );
  }

  return (
    <div className="hotel-special-request-block">
      <p className="hotel-special-request-title">Special Request</p>
      <p className="hotel-special-request-note">
        Note: Special requests are subject to hotel approval and cannot be
        guaranteed
      </p>
      <div className="hotel-special-request-field">
        <TextArea
          rows={4}
          placeholder="Enter your special requests here..."
          value={liveValue}
          onChange={(e) =>
            onChange?.(e.target.value.slice(0, SPECIAL_REQUEST_MAX_LENGTH))
          }
          maxLength={SPECIAL_REQUEST_MAX_LENGTH}
          className="hotel-special-request-textarea"
        />
        <span className="hotel-special-request-count" aria-live="polite">
          {liveValue.length}/{SPECIAL_REQUEST_MAX_LENGTH}
        </span>
      </div>
    </div>
  );
};

export default HotelSpecialRequest;
